export default __webpack_public_path__ + "static/media/coming_soon_bottom.349c42ad.svg";